import styled from 'styled-components';

type InputContainerProps = {
  hasIcon: boolean;
  hasError: boolean;
};

type InputSuffixProps = {
  hasError: boolean;
};

export const Container = styled.div`
  flex: 1;

  label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Sora', sans-serif;
    color: #101d40;
  }
`;

export const InputContainer = styled.div<InputContainerProps>`
  display: flex;
  position: relative;

  svg {
    position: absolute;
    bottom: 50%;
    transform: translateY(50%);
    left: 14px;
    font-size: 24px;
    color: ${({ hasError }) => (hasError ? '#E12021' : '#329bfc')};
  }

  input {
    width: 100%;
    height: 38px;
    border-radius: 5px;
    border: 2px solid ${({ hasError }) => (hasError ? '#E12021' : '#e6effb')};
    padding: 10px;
    color: ${({ hasError }) => (hasError ? '#E12021' : '#101d40')};
    background-color: ${({ hasError }) => (hasError ? '#f8ebec' : '#ffffff')};
    font-size: 13px;
    font-family: 'Sora', sans-serif;
    transition: all 0.2s ease-in-out;
    padding-left: ${({ hasIcon }) => (hasIcon ? '44px' : '14px')};

    &:focus {
      border-color: ${({ hasError }) => (hasError ? '#E12021' : '#329bfc')};

      & + div {
        border-color: ${({ hasError }) => (hasError ? '#E12021' : '#329bfc')};
      }
    }

    &:not(:disabled) {
      &:hover:not(:focus) {
        border-color: ${({ hasError }) => (hasError ? '#E12021' : '#96cdff')};

        & + div {
          border-color: ${({ hasError }) => (hasError ? '#E12021' : '#96cdff')};
        }
      }
    }

    &:disabled {
      cursor: not-allowed;
      background: #e5e5e5;
      border-color: #d9d9d9;

      & + div {
        background: #e5e5e5;
        border-color: #d9d9d9;
      }
    }

    :nth-child(1):not(:only-child) {
      border-radius: 5px 0px 0px 5px;
    }
  }

  .loading {
    position: absolute;
    top: 50%;
    right: 0;
    translate: -50% -50%;
  }
`;

export const InputSuffix = styled.div<InputSuffixProps>`
  border: 2px solid ${({ hasError }) => (hasError ? '#E12021' : '#e6effb')};
  padding: 5px 14px;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  transition: all 0.2s ease-in-out;
  background-color: ${({ hasError }) => (hasError ? '#f8ebec' : '#ffffff')};
  display: flex;
  align-items: center;

  span {
    color: ${({ hasError }) => (hasError ? '#E12021' : '#101d40')};
    font-size: 13px;
    font-weight: 500;
    font-family: 'Sora', sans-serif;
  }
`;


export const InputPreffix = styled.div<InputSuffixProps>`
  border: 2px solid ${({ hasError }) => (hasError ? '#E12021' : '#e6effb')};
  padding: 5px 14px;
  border-radius: 5px 0px 0px 5px;
  border-right: none;
  transition: all 0.2s ease-in-out;
  background-color: ${({ hasError }) => (hasError ? '#f8ebec' : '#ffffff')};
  display: flex;
  align-items: center;

  span {
    color: ${({ hasError }) => (hasError ? '#E12021' : '#101d40')};
    font-size: 13px;
    font-weight: 500;
    font-family: 'Sora', sans-serif;
  }
`;

export const ErrorMessage = styled.div`
  display: block;
  margin-top: 5px;
  font-weight: 500;
  color: #e12021;
  font-size: 14px;
  font-family: 'Sora', sans-serif;
`;
